import React from "react";
import '../css/AboutUs.css'; // Reusing the same CSS for consistent styling
import Navbar from "./Navbar";
import img from '../images/lockersizeim.png'

const LockerSizes = () => {
  return (
    <div className="aboutuspage">
      <div className="content">
        <Navbar />
        <div
          style={{
            maxWidth: 800,
            margin: "40px auto",
            padding: "0 20px",
            fontFamily: "Arial, sans-serif",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <h1 style={{ textAlign: "center", marginBottom: 30, textDecoration: 'underline' }}>
            Locker Sizes
          </h1>
          <div style={{ textAlign: 'center', width: '100%' }}>
            <img 
              src={img} 
              alt="Locker Sizes" 
              style={{ maxWidth: '100%', height: 'auto', margin: '0 auto' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockerSizes;